// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__HOf70","header":"PatientBlock_header__Lf182","label":"PatientBlock_label__2K1Dy","option":"PatientBlock_option__x3ni9"};